import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { isBefore } from 'date-fns';
import * as React from 'react';
import { useTranslations } from '../../hooks/use_translations.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { dateFnsLocaleMap, getDateFormat } from '../../utils/date.js';
import { DateInputBase } from '../DateInput/DateInputBase.js';
import { DateInputPlaceholder } from '../DateInput/DateInputPlaceholder.js';
import { DateSpinButton } from '../DateInput/DateSpinButton.js';
import { DatePicker } from '../DatePicker/DatePicker.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["languageCode", "locale", "modes", "onBlur", "onChange", "placeholder", "presets", "value"];
var DateRangeInput = /*#__PURE__*/React.forwardRef(function DateRangeInput2(props, ref) {
  var languageCode = props.languageCode,
    locale = props.locale,
    modes = props.modes,
    onBlur = props.onBlur,
    _props$onChange = props.onChange,
    _onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    placeholder = props.placeholder,
    presets = props.presets,
    _props$value = props.value,
    value = _props$value === void 0 ? [] : _props$value,
    dateFieldBaseProps = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(!value.length),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    placeholderVisible = _React$useState2[0],
    setPlaceholderVisible = _React$useState2[1];
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  var themeProvidedLocale = (localization === null || localization === void 0 ? void 0 : localization.languageCode) && dateFnsLocaleMap[localization === null || localization === void 0 ? void 0 : localization.languageCode] || dateFnsLocaleMap["en-US"];
  var componentProvidedLocale = languageCode && dateFnsLocaleMap[languageCode] || locale;
  var currentLocale = componentProvidedLocale || themeProvidedLocale;
  var dateFormat = getDateFormat(currentLocale);
  return /*#__PURE__*/jsx(DateInputBase, _objectSpread(_objectSpread({}, dateFieldBaseProps), {}, {
    tabIndex: -1,
    onBlur: onBlur,
    closeButtonProps: {
      onClick: function onClick(e) {
        e.stopPropagation();
        _onChange([]);
        setPlaceholderVisible(true);
      }
    },
    locale: currentLocale,
    ref: ref,
    renderSpinButton: function renderSpinButton(spinButtonProps) {
      return /*#__PURE__*/jsxs("div", {
        style: {
          position: "relative",
          whiteSpace: "nowrap"
        },
        onFocus: function onFocus() {
          return setPlaceholderVisible(!!value.length);
        },
        children: [placeholderVisible && !value.length && /*#__PURE__*/jsx(DateInputPlaceholder, {
          placeholder: placeholder
        }), /*#__PURE__*/jsx(DateSpinButton, _objectSpread(_objectSpread({}, spinButtonProps), {}, {
          "aria-label": t("DateRangeInput.startButton"),
          dateFormat: dateFormat,
          locale: currentLocale,
          onBlur: onBlur,
          onChange: function onChange(date) {
            if (!value[1]) return _onChange([date]);
            if (isBefore(value[1], date)) return _onChange([date, date]);
            return _onChange([date, value[1]]);
          },
          value: value[0]
        })), /*#__PURE__*/jsx("span", {
          style: {
            marginLeft: 10,
            marginRight: 10
          },
          role: "presentation",
          children: "-"
        }), /*#__PURE__*/jsx(DateSpinButton, _objectSpread(_objectSpread({}, spinButtonProps), {}, {
          "aria-label": t("DateRangeInput.endButton"),
          dateFormat: dateFormat,
          locale: currentLocale,
          onBlur: onBlur,
          onChange: function onChange(date) {
            if (!value[0]) return _onChange([]);
            if (isBefore(date, value[0])) return _onChange([date, date]);
            return _onChange([value[0], date]);
          },
          value: value[1]
        }))]
      });
    },
    renderDatePicker: function renderDatePicker(datePickerProps) {
      return /*#__PURE__*/jsx(DatePicker, _objectSpread(_objectSpread({}, datePickerProps), {}, {
        variant: {
          modes: modes,
          onChange: _onChange,
          presets: presets,
          type: "range",
          value: value
        }
      }));
    }
  }));
});
DateRangeInput.displayName = "DateRangeInput";

export { DateRangeInput };
